import React from 'react';
import PropTypes from 'prop-types';
import { processorTargets } from 'config';
import ScreenRadarList from 'screens/Radar/List';
import ScreenRadarCreate from 'screens/Radar/Create';
import ScreenRadarDetail from 'screens/Radar/Details';
import ScreenRadarUpdate from 'screens/Radar/Update';
import { REVIEW_PROCESSOR_LIST } from './paths';

const reviewProcessorListProps = {
  routePaths: REVIEW_PROCESSOR_LIST,
  target: processorTargets.REVIEWS,
};

const routeComponentPropTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

const ScreenReviewProcessorList = props => (
  <ScreenRadarList
    {...props}
    {...reviewProcessorListProps}
    titleKey="review_processor_list.list.title"
  />
);

const ScreenReviewProcessorListCreate = props => (
  <ScreenRadarCreate {...props} {...reviewProcessorListProps} />
);

const ScreenReviewProcessorListDetail = props => (
  <ScreenRadarDetail {...props} {...reviewProcessorListProps} />
);

const ScreenReviewProcessorListUpdate = props => (
  <ScreenRadarUpdate {...props} {...reviewProcessorListProps} />
);

ScreenReviewProcessorList.propTypes = routeComponentPropTypes;
ScreenReviewProcessorListCreate.propTypes = routeComponentPropTypes;
ScreenReviewProcessorListDetail.propTypes = routeComponentPropTypes;
ScreenReviewProcessorListUpdate.propTypes = routeComponentPropTypes;

const reviewProcessorListRoutes = [
  {
    path: REVIEW_PROCESSOR_LIST.LIST,
    name: 'ReviewProcessorList',
    component: ScreenReviewProcessorList,
    allowPermissions: ['view_processorlistitem'],
  },
  {
    path: REVIEW_PROCESSOR_LIST.CREATE,
    name: 'ReviewProcessorListCreate',
    component: ScreenReviewProcessorListCreate,
    allowPermissions: ['add_processorlistitem'],
  },
  {
    path: REVIEW_PROCESSOR_LIST.DETAILS,
    name: 'ReviewProcessorListDetail',
    component: ScreenReviewProcessorListDetail,
    allowPermissions: ['view_processorlistitem'],
  },
  {
    path: REVIEW_PROCESSOR_LIST.UPDATE,
    name: 'ReviewProcessorListUpdate',
    component: ScreenReviewProcessorListUpdate,
    allowPermissions: ['change_processorlistitem'],
  },
];

export default reviewProcessorListRoutes;
